import { createActions, handleActions } from "redux-actions"
import { UserApiService } from "./../../api"

const { setCredentials, setUserData, signOut } = createActions(
	"SET_CREDENTIALS",
	"SET_USER_DATA",
	"SIGN_OUT"
)

const reducer = handleActions(
	{
		[setCredentials]: (state, { payload: { accessToken, tokenType } }) => ({
			...state,
			accessToken,
			tokenType
		}),
		[setUserData]: (state, { payload: user }) => ({
			...state,
			user
		}),
		[signOut]: () => ({
			accessToken: null,
			tokenType: null,
			user: null
		})
	},
	{
		accessToken: null,
		tokenType: null,
		user: null
	}
)

const signIn = ({ accessToken, tokenType }) => async dispatch => {
	await dispatch(
		setCredentials({
			accessToken,
			tokenType
		})
	)
	const user = await UserApiService.getUser()
	await dispatch(setUserData(user))
}

export { signIn, signOut }
export default reducer



// WEBPACK FOOTER //
// ./src/redux/modules/authentication.js